// extracted by mini-css-extract-plugin
export default {"contentWrapper":"TableWrapper_contentWrapper__uIgQu"};